import { Box, IconButton, useTheme } from "@mui/material";
import BlockOutlined from "@mui/icons-material/BlockOutlined";
import { NODE_COLOR_KEYS } from "../nodeColorPalette";
import styles from "./styles";

// Rotulo em pt-BR de cada chave de cor, usado no aria-label dos swatches (acessibilidade nao
// pode depender so da cor)
const NOME_COR = {
  blue: "Azul",
  green: "Verde",
  red: "Vermelho",
  orange: "Laranja",
  yellow: "Amarelo",
  purple: "Roxo",
  pink: "Rosa",
  gray: "Cinza",
};

// Fileira de swatches de cor exibida no menu de contexto do diagrama, pra colorir o(s)
// equipamento(s) selecionado(s) — ver spec cor-nos-equipamentos-diagrama-design.md
export default function NodeColorSwatches({ onSelectColor = () => {} }) {
  const theme = useTheme();
  const swatchStyles = styles(theme);

  return (
    <Box sx={swatchStyles.swatchRow}>
      {NODE_COLOR_KEYS.map((cor) => (
        <IconButton
          key={cor}
          aria-label={`Cor ${NOME_COR[cor]}`}
          onClick={() => onSelectColor(cor)}
          sx={{
            ...swatchStyles.swatchButton,
            backgroundColor: theme?.palette?.colors?.[cor]?.medium,
            "&:hover": {
              backgroundColor: theme?.palette?.colors?.[cor]?.medium,
              opacity: 0.85,
            },
          }}
        />
      ))}
      <IconButton
        aria-label="Sem cor"
        onClick={() => onSelectColor(null)}
        sx={swatchStyles.swatchButton}
      >
        <BlockOutlined sx={swatchStyles.swatchNoneIcon} />
      </IconButton>
    </Box>
  );
}
